import { render, staticRenderFns } from "./TeamProjectTable.vue?vue&type=template&id=e2405f30&"
import script from "./TeamProjectTable.vue?vue&type=script&lang=js&"
export * from "./TeamProjectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports